import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";

/** Fetch a signed URL for a PDF that belongs to the active document workspace. */
export async function fetchPdf(workproductId: string, fileName: string) {
  try {
    const response = await axios.get(
      `${backendUrl}/api/getfile/${workproductId}/${encodeURIComponent(fileName)}`,
      { withCredentials: true }
    );
    return response.data.fileUrl as string;
  } catch (error) {
    console.error("Error fetching PDF file:", error);
    return null;
  }
}
